export default "__VITE_PUBLIC_ASSET__4bea6a50__"